/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Split_Event_LabelInputs */



/**
* | output |
* | --- |
* | "Split Event" |
*
* @param {Split_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_event_label = /** @type {((inputs?: Split_Event_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Event_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scinder l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Split Event")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento diviso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разделенное событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento dividido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分裂事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分割イベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विभाजन घटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento dividido")
	return /** @type {LocalizedString} */ ("Split Event")
});